import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 6a7.75 7.75 0 1 0 10 0","key":"svg-0"}],["path",{"d":"M12 4l0 8","key":"svg-1"}]]

const IconPower = createReactComponent('outline', 'power', 'Power', __iconNode);

export default IconPower;